import { useQuery } from 'react-query';
import axiosInstance from './axiosInstance';

const removeEmptyFields = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) =>
        value != undefined &&
        value != null &&
        !(Array.isArray(value) && value.length === 0) &&
        value !== '',
    ),
  );
};

export const usePostTableData = (data, endpoint, queryKey, enabled = true) => {
  return useQuery({
    queryKey: [queryKey, data],
    queryFn: async () => {
      const filteredBody = removeEmptyFields(data);
      return axiosInstance.post(endpoint, filteredBody);
    },
    enabled: enabled,
  });
};
